/**
 * IM（腾讯云 Chat）身份配置
 */

/**
 * IM 登录/身份所使用的 userInfo 字段。
 * - 'guid': 使用 userInfo.guid（UID），好友关系链的归属账号，默认值
 * - 'id'  : 使用 userInfo.id（平台用户主键）
 *
 * 说明：好友、会话等关系数据在腾讯云按 (SDKAppID, userID) 归属，
 * 切换此配置会改变登录的 IM 身份，进而影响能看到哪一份好友/会话数据。
 * @type {'guid' | 'id'}
 */
export const IM_LOGIN_ID_FIELD = 'guid'

/**
 * 从 userInfo 中取出用于 IM 登录/身份的 userID。
 * 严格按 IM_LOGIN_ID_FIELD 取对应字段（不做跨字段回退，避免不同账号登录到不同身份体系）。
 * @param {object} userInfo 用户信息对象
 * @returns {string} 用于 IM 的 userID；取不到时返回空字符串（initChat 内部会据此跳过登录）
 */
export function getImLoginId(userInfo) {
  if (!userInfo) {
    return ''
  }
  const val = IM_LOGIN_ID_FIELD === 'id' ? userInfo.id : userInfo.guid
  return val != null ? String(val) : ''
}
